import { Box, Typography } from '@mui/material';
import { IPageWrapperProps } from './interfaces';
import { useStyles } from './styles';
import { createGlobalStyle } from 'styled-components';
import { isTablet, isIOS } from 'react-device-detect';

// fix for iPad bouncy scroll bar issue
const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch; /* momentum inside the container */
    overscroll-behavior: contain; /* don’t chain to the viewport */
  }
`;

const PageWrapper = ({
  children,
  bottomElement = null,
  title = '',
  sx = {},
}: IPageWrapperProps) => {
  const classes = useStyles();
  const isIpadFix = isTablet && isIOS;

  return (
    <Box sx={classes.root}>
      {isIpadFix && <GlobalStyle />}
      <Box sx={classes.content}>
        {title && <Typography sx={classes.title}>{title}</Typography>}
        <Box sx={classes.children}>{children}</Box>
      </Box>
      {bottomElement && (
        <Box sx={{ ...classes.bottomElement, ...sx }}>{bottomElement}</Box>
      )}
    </Box>
  );
};

export default PageWrapper;
